import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { map } from 'rxjs';
import { AppointmentTypeService } from 'src/app/services/core/appointment-type/appointment-type.service';
import { CompanyService } from 'src/app/services/core/company/company.service';
import { CredentialService } from 'src/app/services/core/credential/credential.service';
import { FundingSourceService } from 'src/app/services/core/funding-source/funding-source.service';
import { LosService } from 'src/app/services/core/levelOfService/los.service';
import { MemberService } from 'src/app/services/core/member/member.service';
import { PaymentsService } from 'src/app/services/core/payments/payments.service';
@UntilDestroy()

@Component({
  selector: 'app-member-detail-modal',
  templateUrl: './member-detail-modal.component.html',
  styleUrls: ['./member-detail-modal.component.css']
})
export class MemberDetailModalComponent implements OnInit {
  @Input() memberDetailsObj: any
  @Output() closeModal = new EventEmitter<any>();
  currentPage: number = 1;
  member:any;
  paymentMethods: any = [];
  selectedMember: any = '';
  preLevelOfServiceList: any = [];
  preSpaceTypeList: any = []; 
  appointmentTypes: any = [];
  preAppointmentTypes:any = {};
  fundingSourceList: any = [];
  preFundingSource: any = {}
  companies: any
  preCompanies: any

  constructor(private memberService :  MemberService,
    private levelOfService: LosService,
    private appointmentType: AppointmentTypeService,
    private fundingSource: FundingSourceService,
    private credentialService: CredentialService,
    private paymentsService: PaymentsService
  ) {}

  ngOnInit(): void {
    this.getMembersById();
    this.getLevelOfService();
    this.getAppointmentTypes();
    this.getFundingSource();
    this.getAllCompanies();
  }

  onCloseModal() {
    this.closeModal.emit();
  }

  getMembersById() {
    this.memberService.getMemberById(this.memberDetailsObj.id).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
      this.member = data
      this.getPaymentMethods();
      console.log("member details", this.member);
      }
    })
  } 
  getPaymentMethods() {
    const queryParams = {
      member: this.memberDetailsObj.id,
      isActive: true,
      limit: 9999,
      sortBy: 'isDefault:desc,createdAt:desc'
    }
    this.paymentsService.getPaymentMethods(queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      this.paymentMethods = data?.results || [];
    })
  }
  getLevelOfService() {
    let queryParams = {
      limit: 9999,
      isActive: true
    }
    this.levelOfService.getPicker(queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.preSpaceTypeList = data.results
        this.preLevelOfServiceList = this.preSpaceTypeList.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
      }
    })
  }
  getAppointmentTypes() {
    let queryParams = {
      limit: 9999,
      isActive: true
    }
    this.appointmentType.getPicker(queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.appointmentTypes = data.results
        this.preAppointmentTypes = this.appointmentTypes.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
      }
    })
  }
  getFundingSource() {
    let queryParams = {
      limit: 9999,
      isActive: true
    }
    this.fundingSource.getPicker(queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results ) {
        this.fundingSourceList = data.results;
        this.preFundingSource = this.fundingSourceList.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
      }
    })
  }
  getAllCompanies() {
    let queryParams = {
      limit: 9999,
      isActive: true
    } 
    this.credentialService.getPicker(queryParams)
    .subscribe((data: any) => {
      if (data && data.results ) {
        this.companies = data.results;
        this.preCompanies = this.companies.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
      }
    })
  }
}
